import instance from '../../utils/axios';

class DataService {
	async description(tableName) {
	    return await instance.get(`/oa/common/tableGrid/description?tableName=${tableName}`);
	}
    async get(metaId, id) {
        return await instance.get(`/crm/dynamicentity/data/?metaId=${metaId}&id=${id}`);
    }
	async getByTableName(tableName, id) {
	    return await instance.get(`/crm/dynamicentity/data/byTableName/?tableName=${tableName}&id=${id}`);
	}
	async saveByTableName(tableName, data) {
	    return await instance.post(`/crm/dynamicentity/data/byTableName/`, {
	        tableName,
	        json: JSON.stringify(data)
	    })
	}
    async save(metaId, data) {
        return await instance.post(`/crm/dynamicentity/data/`, {
            metaId,
            json: JSON.stringify(data)
        })
    }
}

export default new DataService();